import React from "react";
import style from './Videos.module.css';
import img1 from "./img video/vid-1.jpeg";
import img2 from "./img video/vid-8.jpeg";
import img3 from "./img video/vid-9.jpeg";
import img4 from "./img video/vid-4.jpeg";
import img5 from "./img video/vid-2.jpeg";
import img6 from "./img video/vid-3.jpeg";
import img7 from "./img video/vid-12.jpeg";
import img8 from "./img video/vid-7.jpeg";
import img9 from "./img video/vid-1.jpeg";
import { ReactComponent as Search } from "../../../Redux/icons/search.svg";


const Videos= () => {
    return (
        <div className={style.videosBox}>
            <div className={style.videosHeader}>
                <h5>Videos <span>29</span></h5>
                <form className={style.search}>
                    <input type="search" placeholder="Search Video" className={style.searchInput}/>
                    <div className={style.wrapBtn}>
                        <div className={style.btnSearch}>
                            <input type="submit" name="" value="" className="submit"/>
                            <Search />
                        </div>
                    </div>
                </form>
            </div>
            <div className={style.videos}>
                <div className={style.videoCard}>

                    <a href='https://youtu.be/prfZFyp4XZk'>
                        <img src={img1} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/prfZFyp4XZk'><img  src={img2} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/prfZFyp4XZk' ><img  src={img3} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/V1RPi2MYptM' ><img  src={img4} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/V1RPi2MYptM' ><img  src={img5} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/V1RPi2MYptM' ><img src={img6} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/Migw5SF4yIA'><img src={img7} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/Migw5SF4yIA'><img src={img8} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>

                <div className={style.videoCard}>

                    <a href='https://youtu.be/Migw5SF4yIA'><img src={img9} alt={"video"}/>
                        <i className="fa-sharp fa-solid fa-play"></i></a>
                </div>
            </div>
        </div>
    )
}

export default Videos;